var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text__sr text-secondary",domProps:{"innerHTML":_vm._s(_vm.$i18n.t('cp_pagination_count',
    { from: _vm.getFromItems, to: _vm.getToItems, total: _vm.pagination.totalItems}
  ))}})}
var staticRenderFns = []

export { render, staticRenderFns }